import React, { useState } from 'react';

const videos = [
  {
    id: 'video1',
    title: 'WiCanvas概要',
    description: 'WiCanvasの概要と魅力を紹介いたします。',
    thumbnail: '/org/movie/thumb01.jpg',
    src: '/org/movie/0220_WiCanvas_Teaser.mp4',
    fullDescription: 'WiCanvasの概要と魅力を紹介する動画です。ワイヤレスディスプレイの革新的な技術をご覧ください。',
  },
  {
    id: 'video2',
    title: 'シナリオ動画',
    description: 'WiCanvasの実際の使用シナリオを紹介いたします。',
    thumbnail: '/org/movie/thumb02.jpg',
    src: '/org/movie/WiCanvasScenarioPart2.mp4', // 実際の動画に置き換えてください
    fullDescription: 'WiCanvasの実際の使用シナリオを紹介する動画です。',
  },
];

export const VideoSection: React.FC = () => {
  const [activeVideo, setActiveVideo] = useState(videos[0]);

  return (
    <section id="videos" className="videos">
      <div className="container">
        <h2 className="section-title">動画</h2>
        <div className="videos-content">
          <div className="video-list">
            {videos.map((video) => (
              <button
                key={video.id}
                className={`video-item ${video.id === activeVideo.id ? 'active' : ''}`}
                onClick={() => setActiveVideo(video)}
              >
                <div className="video-thumbnail">
                  <img src={video.thumbnail} alt={video.title} />
                  <div className="play-button">▶</div>
                </div>
                <div className="video-info">
                  <h4>{video.title}</h4>
                  <p>{video.description}</p>
                </div>
              </button>
            ))}
          </div>
          <div className="video-player">
            <video
              key={activeVideo.id}
              controls
              poster={activeVideo.thumbnail}
            >
              <source src={activeVideo.src} type="video/mp4" />
              お使いのブラウザは動画再生に対応していません。
            </video>
            <div className="video-description">
              <h3>{activeVideo.title}</h3>
              <p>{activeVideo.fullDescription}</p>
            </div>
          </div>
        </div>

        {/* Content Creation Service Section */}
        <div className="content-service-section" style={{
          marginTop: '4rem',
          padding: '3rem',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          display: 'flex',
          gap: '2rem',
          alignItems: 'center',
          flexWrap: 'wrap',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
        }}>
          <div className="service-image" style={{ flex: '1 1 300px', textAlign: 'center' }}>
            <img 
              src="/org/service/content-creation.svg" 
              alt="Content Creation Service" 
              style={{ maxWidth: '100%', height: 'auto', maxHeight: '250px' }}
            />
          </div>
          <div className="service-content" style={{ flex: '1 1 300px' }}>
            <h3 style={{ 
              fontSize: '1.8rem', 
              color: '#0056b3', 
              marginBottom: '1rem',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '0.5rem',
              display: 'inline-block'
            }}>
              ワンストップ・ソリューション
            </h3>
            <h4 style={{ fontSize: '1.2rem', marginBottom: '1rem', color: '#333' }}>
              システムからコンテンツまでトータルでご用命いただけます
            </h4>
            <p style={{ lineHeight: '1.8', color: '#555', fontSize: '1.05rem' }}>
              WiCanvasの導入におけるハードウェアの選定・設置だけでなく、
              そこで放映する<strong>映像コンテンツの企画・制作</strong>までトータルでサポートいたします。
            </p>
            <p style={{ lineHeight: '1.8', color: '#555', marginTop: '1rem', fontSize: '1.05rem' }}>
              デジタルサイネージの効果を最大化するには、魅力的なコンテンツが不可欠です。
              専任のクリエイティブチームが、お客様のブランドイメージや目的に合わせた最適な映像をご提案・制作いたします。
            </p>
            <div style={{ marginTop: '1.5rem' }}>
              <a href="#contact" className="btn btn-primary">
                制作について相談する
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
